import { afterNextRender, Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { DataLayerService } from '@modules/shared/services/data-layer.service';
import { BufferingComponent } from '@modules/ui/buffering/buffering.component';
import { Locale } from 'src/environments/language.config';

const SUBSCRIBE_FORM_URLS: { [key: string]: string } = {
  [Locale.DE]: 'https://mailing.mercedes-benz.com/-optin-form/30669/5/BmGQD',
  [Locale.EN]: 'https://mailing.mercedes-benz.com/-optin-form/30669/6/BmGQD',
};

@Component({
  selector: 'mb-newsletter-subscribe',
  template: `
    @if (showBuffer) {
      <mb-buffering></mb-buffering>
    }
    <iframe frameBorder="0" width="100%" height="700" [src]="url" (load)="showBuffer = false"></iframe>
  `,
  styles: [
    `
      :host {
        width: var(--wb-grid-width);
        margin: 0 auto;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BufferingComponent],
})
export class NewsletterSubscribeComponent {
  private dataLayerService = inject(DataLayerService);

  url: SafeResourceUrl | undefined;
  showBuffer = true;

  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const translateService = inject(TranslateService);

    afterNextRender(() => {
      this.url = domSanitizer.bypassSecurityTrustResourceUrl(
        SUBSCRIBE_FORM_URLS[translateService.currentLang() ?? Locale.DE]
      );
      translateService.onLangChange.subscribe((langChangeEvent) => {
        this.url = domSanitizer.bypassSecurityTrustResourceUrl(SUBSCRIBE_FORM_URLS[langChangeEvent.lang]);
        this.pushPageView();
      });

      this.pushPageView();
    });
  }

  private pushPageView() {
    this.dataLayerService.pushPageView({
      id: undefined,
      type: 'newsletter_subscribe',
      name: undefined,
      publishDate: undefined,
      marsOriginId: undefined,
    });
  }
}
